import { SessionRelevantInfo } from '@tableau/workbook-templates-widgets/lib/src/components/template_item/TemplateDescription';
import { SessionManagementService } from '../../sessionManagement/SessionManagementService';

export function buildSessionRelevantInfo(serverService: SessionManagementService): SessionRelevantInfo {
    return {
        oauthSettings: serverService.oauthSettings(),
        serverBuild: serverService.sessionServerVersion().build,
        serverVersion: serverService.sessionServerVersion().platform,
        langauge: serverService.sessionLanguage(),
    };
}